/** @format */

import { provisionigConstants } from './action';

export function provisioningReducers(state = {}, action) {
    switch (action.type) {
        case provisionigConstants.LIST:
        case provisionigConstants.MVNO_BLOCK_API_REQUEST_LIST:
            return {
                type: action.type,
                items: action.collections,
            };
        case provisionigConstants.MVNO_BLOCK_REQUEST_STATE_LIST:
            return {
                type: action.type,
                blockStateList: action.collections,
                viewItem: state.viewItem,
            };
        case provisionigConstants.ITEM:
            return {
                type: action.type,
                item: action.item,
            };
        case provisionigConstants.PLK_LIST_VIEW:
            return {
                type: action.type,
                items: action.collections,
            };
        case provisionigConstants.PLK_LIST_VIEW_ITEM:
            return {
                type: action.type,
                viewItem: action.item,
            };
        case provisionigConstants.BLOCK_LIST:
            return {
                type: action.type,
                blockList: action.collections,
            };
        case provisionigConstants.NOTIFY_PLK_LIST:
            return {
                type: action.type,
                plusNotify: action.collections,
            };
        default:
            return {
                ...state,
                type: null,
            };
    }
}
